module.exports = __webpack_public_path__ + "static/corl_logo-db9d6312107d98e37fc70e6d684d4d41.png";